/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetUserAnswersFromHistoryRequest,
  TGetUserAnswersFromHistoryModel,
  IMappers,
  TGetUserAnswersFromHistoryResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetUserAnswersFromHistoryV2Response } from '../../entities/estimation/GetUserAnswersFromHistoryV2Response';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetUserAnswersFromHistoryModel(
  parameters: TGetUserAnswersFromHistoryRequest,
): TGetUserAnswersFromHistoryModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/v2/get-user-answers-from-history/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetUserAnswersFromHistoryOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetUserAnswersFromHistoryRequest;
}

export async function fetchGetUserAnswersFromHistory<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetUserAnswersFromHistoryOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetUserAnswersFromHistoryResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetUserAnswersFromHistoryModel(parameters),
    config,
  )) as FetchResponse<TGetUserAnswersFromHistoryResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetUserAnswersFromHistoryV2Response, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetUserAnswersFromHistoryResponse>;
}
